import React from "react"
import { FiUser } from "react-icons/fi";
import { IoIosLogOut } from "react-icons/io";
import { setToken } from "../../utils/token";
import { useNavigate } from "react-router-dom";
import Popup from "reactjs-popup";
import ButtonComponent from "../button/Button";


const TopBar = () => {
    const navigate = useNavigate()
    const Logout = () => {
        setToken()
        navigate("/login")
    }
    return (
      <div className="text-color-white2 shadow-sm flex justify-between w-full px-20 py-5 bg-color-primary-dark1">
        <div>
          <div>Admin Panel</div>
        </div>
        <div className="flex space-x-5 items-center">
          <div>
            <FiUser size={25} />
          </div>
          <div onClick={Logout} className="cursor-pointer">
            <Popup
              trigger={
                <button>
                  <IoIosLogOut size={25} />
                </button>
              }
              position="bottom right"
              // open={openPopup}
            >
              {(close) => (
                <div className="px-16 py-10">
                  {/* Delete model Top */}
                  <div>
                    <div className="text-4xl text-red-500 font-semibold">
                      LOGOUT
                    </div>
                  </div>

                  {/* MODAL Content */}
                  <div className="my-5">
                    <div>
                      Are you sure you want to logout?
                    </div>
                  </div>

                  {/* BUTTONS */}
                  <div className="flex space-x-5">
                    <div onClick={close}>
                      <ButtonComponent name={"Cancel"} type={"cancel"} />
                    </div>
                    <div onClick={Logout}>
                      <ButtonComponent
                        name={"Logout"}
                        type={"delete"}
                        disabled={false}
                      />
                    </div>

                    {/* {deleteLoading && <div>Loading...</div>} */}
                  </div>
                </div>
              )}
            </Popup>
          </div>
        </div>
      </div>
    );
}

export default TopBar